import Api from "./Api.js";
const Signin = (email, password) => {
  return Api().post("/auth/login", { email, password });
};

const Signup = (form) => {
  console.log(form);
  return Api().post("/auth/register", { ...form });
};

const ConfirmarEmail = (email) => {
  return Api().post("/auth/forgot-password", email);
};

const TrocarSenha = ({ token, newPassword }) => {
  return Api().post("/auth/reset-password", { token, newPassword });
};
export { Signin, Signup, ConfirmarEmail, TrocarSenha };
